import environment from "src/utils/environment";
const { app } = window.require("@electron/remote");

export function getLocale() {
  if (environment.isBrowser) return navigator.language;
  return environment.forcedLocale || app.getLocale();
}

export function getLocaleCountryCode() {
  if (environment.isBrowser) return undefined;
  return app.getLocaleCountryCode();
}
